import {inject, Injectable} from '@angular/core';
import {DialogService, I18nService, NotificationService, PreferenceService, ProjectService} from "@wms/services";
import {environment} from "../../../environments/environment";
import {EventManagerService} from "@wms/app";
import {WmsWorkspaceManagerService} from "@wms/workspace";

@Injectable({
  providedIn: 'root'
})
export class PreviewService {
  public windowObj: any;
  public previewUrl: string;
  private selectedViewport: any;
  private notificationService = inject(NotificationService);
  private locale: any = inject(I18nService).getMessages();

  constructor(private projectService: ProjectService, private i18nService: I18nService,
              private dialogService: DialogService, private eventManager: EventManagerService,
              private wsManager: WmsWorkspaceManagerService, private preferenceService: PreferenceService) {
    this.eventManager.viewportSelectionObservable().subscribe((viewport: any) => {
      this.selectedViewport = viewport;
    })
  }

  private saveProject() : Promise<any> {
    return new Promise((resolve, reject) => {
      this.wsManager.saveActiveWs.next(() => { resolve('') });
    });
  }

  public deployProject(silent?: boolean) : Promise<any> {
    return this.projectService.getAppRunURL(!silent);
  }

  getAppPreviewUrl(pageName: string, deployedUrl: string) {

    let url, device;

    let project = this.projectService.getDetails(),
     selectedLocale = this.i18nService.getAppDefaultLocale();

    if (!this.selectedViewport || !this.selectedViewport.id) {
      device = this.projectService.isMobileApplicationType() ? 'iphone_5' : '';
    } else {
      device = this.selectedViewport.id;
    }
    url = './preview?project-id=' + project.id + '#/?' +
      $.param({
        'app_url'         : deployedUrl + '/' + '#/' + (pageName || ''),
        'app_type'        : project.type,
        'app_name'        : project.name,
        'platform_type'   : project.properties.platformType,
        'device'          : device,
        'app_displayname' : project.displayName,
        'device_types'    : project.properties.deviceTypes,
        'selectedlocale'  : selectedLocale,
        'pagename'        : pageName || this.projectService.getHomePage()
      });

    return url;
  }

  private replaceDeployUrlWhenLocal(deployedUrl: string) {
    let modifiedDeployUrl = deployedUrl;
    if (!environment.production) {
      let _url = deployedUrl;
      if (!_url.startsWith('http')) {
        _url = 'https://' + deployedUrl;
      }
      let url = new URL(_url);
      modifiedDeployUrl = deployedUrl.replace('https://', 'http://').replace(url.hostname, window.location.host);
    }
    return modifiedDeployUrl;
  }

  private openAppPreviewWindow(pageName: string, action?: string) {
    const deployedUrl = this.projectService.getDeployedUrl();
    let modifiedDeployUrl =  this.replaceDeployUrlWhenLocal(deployedUrl);

    this.previewUrl = action === 'RUN-DEBUG' ? modifiedDeployUrl + '/#/' : this.getAppPreviewUrl(pageName, modifiedDeployUrl);

    //If the window is already opened, force reload it. Else, open the application in a new window
    if (this.windowObj && !this.windowObj.closed) {
      this.windowObj.location.href = this.previewUrl;
      this.windowObj.location.reload(true);
    } else {
      this.windowObj = window.open(this.previewUrl, '_blank');
    }

    // if windowObj created, then focus on it
    // else, popup blocker is enabled.
    if (this.windowObj) {
      window.blur();
      this.windowObj.focus();
    } else {
      this.dialogService.open('popupBlockerDialog');
    }
  }

  private saveAndDeployProject(silent?: boolean) {
    return this.saveProject().then(this.deployProject.bind(this, silent));
  }

  // Inplace deploys the app, loads the home page of the app
  previewApp(action?: string, silent = false) {
    return this.saveAndDeployProject(silent).then(() => {
        !silent && this.openAppPreviewWindow('', action);
      }).catch((error) => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
      });
  }

  // Inplace deploys the app, loads the active page in the app
  previewPage(pageName: string, action: string) {
    return this.saveAndDeployProject().then(this.openAppPreviewWindow.bind(this, pageName, action))
      .catch((error) => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
      });
  }
}
